import { useMemo } from 'react';
import { useIntl } from 'react-intl';

const useSelectAll = ({ enableSelectAll, items, selectedValues, enableMultiSelect, selectAllLabelHandler }) => {
    const intl = useIntl();
    const showSelectAll = enableSelectAll && enableMultiSelect && items.length > 1;
    const allSelected = useMemo(() => {
        if (!showSelectAll)
            return false;
        return items.every((item) => item.disabled || selectedValues.includes(item.value));
    }, [items, selectedValues, showSelectAll]);
    const selectAllItem = useMemo(() => {
        if (!showSelectAll)
            return {};
        const selectedFilteredItems = items.filter((item) => selectedValues.includes(item.value)).length;
        const selectedItemsLabel = intl.formatMessage({
            defaultMessage: '{selected} of {total} selected',
            id: 'EKDPMN',
            description: 'Label for select all checkbox displaying current selected count'
        }, {
            selected: selectedFilteredItems,
            total: items.length
        });
        const selectAllLabel = typeof selectAllLabelHandler === 'function'
            ? selectAllLabelHandler()
            : intl.formatMessage({
                defaultMessage: 'Select All ({total} results)',
                id: 'Ym8W1b',
                description: 'Label for select all checkbox displaying current selected count'
            }, {
                selected: selectedFilteredItems,
                total: items.length
            });
        return {
            value: selectedFilteredItems ? selectedItemsLabel : selectAllLabel,
            checked: allSelected,
            indeterminate: !allSelected && selectedValues.length > 0
        };
    }, [showSelectAll, selectedValues, items]);
    return { allSelected, selectAllItem, showSelectAll };
};

export { useSelectAll };
//# sourceMappingURL=useSelectAll.esm.js.map
